// @flow
import {
  AssetIdJson,
  FilesResponseData,
  LoadNextSearchPageMsg,
  LoadNextSearchPageQuery,
  RepoItem,
  SearchMessage,
  SearchQuery,
  ApplyFilterQuery,
  ApplyFilterMsg,
  GetFacetsQuery,
  GetFacetsMsg,
  GetFacetsRes,
  CurrentContextInfo,
  GetMetadataHelpQueryMsg,
  GetMetadataHelpQueryQuery,
  FilesStatData,
  FacetedItemInfo,
  SearchInsideQuery
} from './../autogenerated/ZoomBridge';
import SearchParamUtil from './SearchParamUtil';
import ViewUtil from '../ViewUtil';
import StringUtil from './StringUtil';
import HashMap from '../protocol/HashMap';
import MetadataUtil from './MetadataUtil';
import _ from 'lodash';
import Store from '../store/Store';
import { CONTEXT_INFO, CATEGORY_LIST, ADV_SRCH_ASSETS, ADV_SRCH_COLLECTIONS, GLOBAL_SEARCH_INFO } from '../store/Constants';
import {
  SORT_BY_MTIME,
  METADATA_VALUES,
  METADATA_LOGICAL_RELATIONSHIPS,
  METADATA_KEYS,
  SEARCH_STRING,
  VALUE_LENGTH,
  HIDE,
  PIN_TO_TOP,
  PATH_PROJECT,
  FILE_TYPE,
  AUTHOR,
  CHECK_IN_DATE_RANGE,
  COMMENTS,
  FILE_NAME_MATCH_ENUM,
  PATH_ACTIONS,
  PATH_ACTIONS_NOT,
  LINKAGE_ROLES,
  LINKAGE_ROLES_NOT,
  ASSET_ID
} from '../util/Constants';
import Storage from '../protocol/Storage';
import moment from 'moment';
import { runCategoryChangeQuery } from '../util/RepoItemUtil';
import { getFilterLabel, updateCategoryList } from '../util/FacetUtil';
import SaveSettings from '../queries/settings/SaveSettings';
import SearchInsideClientQuery from '../search/SearchInsideClientQuery';

const debug = require('../debug/debug')('wc:util:SearchUtil');
const SEARCH_TYPES = Object.freeze({
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  BEGINS_WITH: 'BEGINS_WITH',
  ENDS_WITH: 'ENDS_WITH',
  IN_RANGE: 'IN_RANGE',
  NOT_IN_RANGE: 'NOT_IN_RANGE',
  EXACT: 'EXACT'
});
const regx = new RegExp('/|/');
export type SearchType = $Keys<typeof SEARCH_TYPES>;
export interface SystemMetadataFilter {
  key: string;
  value: string;
  vme: SearchType;
};

export default class SearchUtil {
  static async searchInsideResponse(searchText) {
    const query = new SearchInsideClientQuery(searchText);
    const res = await query.run();
    return res;
  }

  /**
   * Runs a SearchQuery for filenames matching `regExString` with the given `searchType`
   */
  static searchFile(regExString: string, searchType: SearchType) {
    const cid = ViewUtil.getCollectionIdFromArgs();
    const message = new SearchMessage()
      .setFileName(regExString)
      .setOnlyFiles(true)
      .setFileNameMatchEnum(searchType);
    if (cid > 0) {
      message.setCollectionId(cid);
      message.setOnlyCollections(true);
    }
    const query = new SearchQuery();
    query.message = message;
    return query.run().then((resp: FilesResponseData) => resp.getResultFiles());
  }

  static async searchQuery(searchString: string, options = false): Promise<FilesResponseData> {
    if (searchString && searchString.indexOf(':') !== -1) {
      var array: Array<string> = searchString.split(';');
      if (array && array.length > 0) {
        const map: Map<string, string> = new Map();
        const assetIdFilterList: Array<AssetIdJson> = [];
        for (var i: number = 0; i < array.length; i++) {
          var item: string = array[i];
          item = item.trim();
          var metadata: Array<string> = item.split(':');
          if (metadata && metadata.length > 0) {
            var key: string = metadata[0];
            var value: string = metadata[1];
            key = key.trim();
            value = value.trim();
            if (key.charAt(4) == ' ') {
              key = key.substr(0, 4).toUpperCase() + '_' + StringUtil.toCamelCase(key.substring(5), ' ');
            }
            let fuid = 0;
            if ((fuid = SearchUtil.getFuidKey(key, value)) > 0) {
              assetIdFilterList.push(SearchUtil.createAssetIdJson(fuid));
            } else {
              map.set(key, value);
            }
          }
        }
        if (map.size > 0 || assetIdFilterList.length > 0) {
          return this.searchInMetadata(map, undefined, assetIdFilterList, options);
        }
      }
    }
    // const map: Map<string, string> = new Map();
    // return this.searchInMetadata(map);
    // Although both auto search and search query looks same but in future it might change hence 2 seperate functions
    //$FlowFixMe: Assumed type from CONTEXT_INFO is CurrentContextInfo
    const info: CurrentContextInfo = _.cloneDeep(Store.get(CONTEXT_INFO));
    let field = info.getSortCriteria().toLowerCase();
    let isSortReset = false;
    // if (field !== 'name' || field === 'kind') {
    //   if (field === 'kind') {
    //     isSortReset = true;
    //   }
    //   field = 'mtime';
    // }

    // info.setSortCriteria(field);

    const searchQuery = new SearchQuery();
    let message = new SearchMessage();

    message.setText(searchString);

    if (options) {
      message.setResetFilters(options.isReset);
      message.setCurrentContextInfo(options.info);
      if (options.fileFilters && options.fileFilters.getFilterText()) {
        message.setSearchInsideText(options.fileFilters.getFilterText());
      }
      if (options.resetAllExceptFilters && !options.isReset) {
        message.setResetAllExceptFilters(options.resetAllExceptFilters);
      }
    } else {
      const categoryList = Store.get(CATEGORY_LIST);
      const hasFilters = (categoryList || []).filter((category) => category.isHasAnySelectedItem()).length > 0;
      message.setResetAll(!hasFilters);
      message.setResetAllExceptFilters(true);
      message.setCurrentContextInfo(info);
      message.setDirtyArg(SearchParamUtil.TEXT);
    }
    message = SearchUtil.setCommonParameterOfSearchMessage(message);

    searchQuery.message = message;
    if (isSortReset) {
      // info.setSortCriteria(SORT_BY_MTIME);
      Store.put(CONTEXT_INFO, info);
    }
    const res: FilesResponseData = await searchQuery.run();
    //MetadataUtil.addAssetIdInMetadataMapOfAsset(res.getResultFiles());
    return res;
  }

  static searchAutoCompleteQuery(searchString: string, selectedFilePaths = null, metadataKey: string = null, getController = () => { }): Promise<FilesResponseData> {
    const searchQuery = new SearchQuery();
    let message = new SearchMessage();

    if (metadataKey == null || metadataKey == 'SYST_Search Everywhere') {
      message.setText(searchString);
      message.setSearchInCollectionFiles(true);
      message.setSearchInCollectionNames(true);
      message.setOnlyBins(true);
      message.setOnlyCollections(true);
      message.setSearchInMetadata(true);
    } else {
      message.setSearchInCollectionFiles(false);
      message.setSearchInCollectionNames(false);
      message.setOnlyBins(false);
      message.setOnlyCollections(false);
      message.setSearchInMetadata(true);
      if (metadataKey == 'SYST_File Name') {
        message.setFileName(searchString);
        message.setFileNameMatchEnum('CONTAINS');
      } else if (metadataKey == 'SYST_Author') {
        message.setAuthor(searchString);
        message.setAuthorMatcher('CONTAINS');
      } else if (metadataKey == 'SYST_LogMsg') {
        message.setLog(searchString);
        message.setLogMatcher('CONTAINS');
      } else if (metadataKey == 'SYST_Path Action') {
        message.setPathActionFilters([searchString]);
        message.setNotPathActionList([false]);
      } else if (metadataKey == 'SYST_Linkage Role') {
        message.setLinkageRoleFilters([searchString]);
        message.setNotLinkageRoleList([false]);
      } else {
        message.setProperties([metadataKey]);
        message.setValues([searchString]);
      }
    }
    message.setDirtyArg(SearchParamUtil.TEXT);
    message.setResetAllExceptFilters(true);
    message.setAutoCompleteQuery(true);
    message.setResultLimitPerCategory(5);
    message = SearchUtil.setCommonParameterOfSearchMessage(message);
    if (selectedFilePaths && selectedFilePaths.length && selectedFilePaths[0].path) {
      message.setFlexPath(selectedFilePaths);
    }

    searchQuery.message = message;

    return searchQuery.run(undefined, undefined, getController);
  }

  static searchCollectionAutoComplete(searchString: string, onlyBins = true, onlyCollections = true, getController = () => { }): Promise<FilesResponseData> {
    const searchQuery = new SearchQuery();
    let message = new SearchMessage();
    message.setText(searchString);
    message.setSearchInCollectionFiles(false);
    message.setSearchInCollectionNames(true);
    message.setOnlyBins(onlyBins);
    message.setOnlyCollections(onlyCollections);
    message.setAutoCompleteQuery(true);
    message.setResultLimitPerCategory(5);
    searchQuery.message = message;

    return searchQuery.run(undefined, undefined, getController);
  }

  static searchCollections(searchString: string, onlyBins = true, onlyCollections = true, getController = () => { }): Promise<FilesResponseData> {
    const searchQuery = new SearchQuery();
    let message = new SearchMessage();
    message.setText(searchString);
    message.setSearchInCollectionFiles(false);
    message.setSearchInCollectionNames(true);
    message.setOnlyBins(onlyBins);
    message.setOnlyCollections(onlyCollections);
    message.setResultLimitPerCategory(50);
    message.setAutoCompleteQuery(true);
    searchQuery.message = message;

    return searchQuery.run(undefined, undefined, getController);
  }

  /**
   * Searches all the subclips for a given clip. The @param baseFuid denotes the asset id of the base clip.
   * The method issues a find command to search all the subclips having a specific miscellaneous metadata key
   * ie. "MISC_Clip Source Asset Id"
   * @param baseFuid
   * @returns {Promise}
   */
  static searchSubClipsQuery(baseFuid: number) {
    //calling
    const searchQuery = new SearchQuery();
    let message = new SearchMessage();
    const key: string = 'MISC_Clip Source Asset Id';

    message.setProperties([key]);
    message.setValues(['' + baseFuid]);
    message.setSearchInMetadata(true);
    message.setUberSearch(false);
    message.setDirtyArg(key);
    message = SearchUtil.setCommonParameterOfSearchMessage(message);
    searchQuery.message = message;
    return searchQuery.run();
  }

  static async fetchAssetByFuid(fuid: string): Promise<RepoItem> {
    const query = new SearchQuery();
    const msg = new SearchMessage();
    const assetIdJson = new AssetIdJson().setFuidStr(fuid);
    msg.setAssetIdFilterList([assetIdJson]);
    msg.setDirtyArg('MISC_Clip Source Asset Id');
    query.message = msg;
    const res: FilesResponseData = await query.run();
    return res.getResultFiles()[0];
  }

  static async fetchAssetsByFuids(fuids: number[]): Promise<RepoItem[]> {
    const query = new SearchQuery();
    const msg = new SearchMessage();
    const assetIdJsonArray = fuids.map((fuid) => new AssetIdJson().setFuidStr(String(fuid)));
    msg.setAssetIdFilterList(assetIdJsonArray);
    msg.setDirtyArg(SearchParamUtil.ASSETID_FILTER_LIST);
    query.message = msg;
    const res: FilesResponseData = await query.run();
    return res.getResultFiles();
  }

  static isRangeTypeValue(value: string): boolean {
    return regx.test(value);
  }

  static parseDateType(value: string): string {
    return SearchUtil.convertDateToTimeStamp(value);
  }

  static isDateRangeFormatString(str: string): boolean {
    //Todo: @Deprecated method. In future, we have to remove this method. As it is depending on the text format to detect date type.
    //Looking for format like: MM/DD/YYYY-MM/DD/YYYY
    //This method is added in hurry, do not use it. Please - Om
    if (str) {
      const dates = str.split('-');
      if (dates.length === 2) {
        const date1 = dates[0];
        const date2 = dates[1];
        if (date1.indexOf('/') !== -1 && date2.indexOf('/') !== -1) {
          return true;
        }
      }
    }
    return false;
  }

  static convertDateToTimeStamp(date: string): string {
    //Todo: @Deprecated method. In future, we have to remove this method. As it is depending on the text format to detect date type.
    const dates = date.split('-');
    if (dates.length === 2) {
      const date1 = dates[0];
      const date2 = dates[1];
      if (date1.indexOf('/') !== -1 && date2.indexOf('/') !== -1) {
        return moment(dates[0], 'MM/DD/YYYY').unix() + '000' + '|' + moment(dates[1], 'MM/DD/YYYY').unix() + '000';
      }
    }
    return date;
  }

  static getValueAndLogicalRelation(values: Array<string>, key: string): Object {
    let propertyValue = [],
      logicalRelation = [],
      keys = [],
      valueMatchEnums = [];
    if (values.length > 1) {
      _.each(values, (entry) => {
        if (entry === 'OR' || entry === 'AND') {
          logicalRelation.push(entry);
        } else {
          const valueToEnum = SearchUtil.parseMetadataValue(entry);
          propertyValue.push(valueToEnum.value);
          valueMatchEnums.push(valueToEnum.vme);
          keys.push(key);
        }
      });
    } else {
      const valueToEnum = SearchUtil.parseMetadataValue(values[0]);
      propertyValue.push(valueToEnum.value);
      valueMatchEnums.push(valueToEnum.vme);
      keys.push(key);
    }
    return {
      property: propertyValue,
      logical: logicalRelation,
      keys: keys,
      valueMatchEnums: valueMatchEnums
    };
  }

  static putGapForSameDateTime = (range: string) => {
    const dates: Array<string> = range.split('|');
    if (dates.length === 2) {
      if (dates[0] === dates[1]) {
        const endDate = parseInt(dates[1]) + 86399999;
        return `${dates[0]}|${endDate}`;
      } else {
        return range;
      }
    } else return range;
  };

  static parseMetadataValue(value: string): Object {
    let newValue: string;
    let matchEnum: SearchType;
    if (SearchUtil.isDateRangeFormatString(value)) {
      newValue = SearchUtil.putGapForSameDateTime(SearchUtil.parseDateType(value));
      matchEnum = 'IN_RANGE';
    } else if (SearchUtil.isRangeTypeValue(value)) {
      newValue = value;
      matchEnum = 'IN_RANGE';
    } else {
      if ((value.startsWith('"') || value.startsWith("'")) && (value.endsWith('"') || value.endsWith("'"))) {
        newValue = value.substring(1, value.length - 1);
        matchEnum = 'EXACT';
      } else {
        if (value.indexOf(' ') !== -1) {
          newValue = value.split(' ').join('*');
        } else {
          newValue = value;
        }
        matchEnum = 'CONTAINS';
      }
    }
    return { value: newValue, vme: matchEnum };
  }

  static parseMetadataValues(metadataValues: Array<string>): Array<Object> {
    const valueAndEnums: Array<Object> = [];
    metadataValues.forEach((value) => {
      valueAndEnums.push(SearchUtil.parseMetadataValue(value));
    });
    return valueAndEnums;
  }

  static extractValuesFromValueAndEnums(valueAndEnums: Array<Object>): Array<string> {
    const values: Array<string> = [];
    valueAndEnums.forEach((valueAndEnum) => {
      values.push(valueAndEnum.value);
    });
    return values;
  }

  static extractMatchEnumsFromValueAndEnums(valueAndEnums: Array<Object>): Array<SearchType> {
    const matchEnums: Array<SearchType> = [];
    valueAndEnums.forEach((valueAndEnum) => {
      matchEnums.push(valueAndEnum.vme);
    });
    return matchEnums;
  }

  static getMetaDataProperties(metaDataKeys: ?Array<string>, valueLength: ?Array<number>): Array<string> {
    const newMetaDataProperties = [];
    if (metaDataKeys)
      metaDataKeys.forEach((value, index) => {
        //$FlowFixMe
        newMetaDataProperties.push(..._.fill(Array(valueLength[index]), value));
      });
    return newMetaDataProperties;
  }

  /**
   *
   * @param {Map<string,Array<string>} metadata
   */

  static isShowDirs = () => {
    const findOnlyFolder = SaveSettings.getBoolean(SaveSettings.FIND_ONLY_FOLDERS);
    const isGlobalSearchInfoActive = Store.get(GLOBAL_SEARCH_INFO)?.active;
    if(findOnlyFolder) {
        if(isGlobalSearchInfoActive) return true;
        else if(ViewUtil.isSeachTabActive()) return true;
        else return false;
    } else return false;
  }

  static setCommonParameterOfSearchMessage(searchMessage: SearchMessage) {
    const isShowDirs: boolean = SearchUtil.isShowDirs();
    searchMessage.setOnlyFiles(true);
    searchMessage.setOnlyDirs(isShowDirs);
    searchMessage.setShowDeleted(SaveSettings.getBoolean(SaveSettings.FIND_SEARCH_SHOW_DELETED));
    searchMessage.setShowArchived(SaveSettings.getBoolean(SaveSettings.FIND_SEARCH_SHOW_ARCHIVED));
    searchMessage.setShowExpired(SaveSettings.getBoolean(SaveSettings.FIND_SEARCH_SHOW_EXPIRED));
    return searchMessage;
  }

  static async advanceSearchInMetadata(
    metadata: Map<string, Array<string>>,
    isReturn = false
  ): Promise<FilesResponseData> {
    debug('[advanceSearchInMetadata(metadata: %o)]', metadata);
    let searchMessage = new SearchMessage();
    let assetIdFilterList: Array<AssetIdJson> = [];
    const info: CurrentContextInfo = _.cloneDeep(Store.get(CONTEXT_INFO));
    searchMessage.setCurrentContextInfo(info);
    searchMessage.setProperties(
      SearchUtil.getMetaDataProperties(metadata.get(METADATA_KEYS), metadata.get(VALUE_LENGTH))
    );
    let valueAndEnums: Array<Object> = SearchUtil.parseMetadataValues(metadata.get(METADATA_VALUES));
    searchMessage.setValues(SearchUtil.extractValuesFromValueAndEnums(valueAndEnums));
    searchMessage.setValueMatchEnums(SearchUtil.extractMatchEnumsFromValueAndEnums(valueAndEnums));
    searchMessage.setMetaPropertiesRelationship(metadata.get(METADATA_LOGICAL_RELATIONSHIPS));
    searchMessage.setResetAllExceptFilters(true);
    searchMessage.setResetAll(true);
    searchMessage.setDirtyArg(SearchParamUtil.TEXT);
    searchMessage.setFlexPath(metadata.get(PATH_PROJECT));
    if (metadata.has(AUTHOR)) {
      searchMessage.setAuthor(metadata.get(AUTHOR));
      const authorSearchType: SearchType = 'CONTAINS';
      searchMessage.setAuthorMatcher(authorSearchType);
    }
    if (metadata.has(FILE_TYPE)) searchMessage.setTypeFilters(metadata.get(FILE_TYPE));
    if (metadata.has(COMMENTS)) {
      searchMessage.setLog(metadata.get(COMMENTS));
      const logSearchType: SearchType = 'CONTAINS';
      searchMessage.setLogMatcher(logSearchType);
    }
    if (metadata.has(CHECK_IN_DATE_RANGE)) {
      const dates = ('' + metadata.get(CHECK_IN_DATE_RANGE)).split('-');
      searchMessage.setBeginDate(dates[0].trim());
      searchMessage.setLastDate(dates[1].trim());
    }
    if (metadata.has(PATH_ACTIONS)) {
      searchMessage.setPathActionFilters(metadata.get(PATH_ACTIONS));
      searchMessage.setNotPathActionList(metadata.get(PATH_ACTIONS_NOT));
    }
    if (metadata.has(LINKAGE_ROLES)) {
      searchMessage.setLinkageRoleFilters(metadata.get(LINKAGE_ROLES));
      searchMessage.setNotLinkageRoleList(metadata.get(LINKAGE_ROLES_NOT));
    }
    if (metadata.has(ASSET_ID)) {
      assetIdFilterList.push(SearchUtil.createAssetIdJson(metadata.get(ASSET_ID)));
      searchMessage.setAssetIdFilterList(assetIdFilterList);
    }
    searchMessage.setFileName(metadata.get(SEARCH_STRING));
    searchMessage.setFileNameMatchEnum(metadata.get(FILE_NAME_MATCH_ENUM));
    searchMessage = SearchUtil.setCommonParameterOfSearchMessage(searchMessage);
    if (isReturn) return new Promise((resolve) => resolve(searchMessage));
    const searchQuery = new SearchQuery();
    searchQuery.message = searchMessage;
    //AI_TYPE
    const res: FilesResponseData = await searchQuery.run(true);
    //MetadataUtil.addAssetIdInMetadataMapOfAsset(res.getResultFiles());
    return res;
  }

  /**
   *
   * @param {Map<string,string>} metadata
   */
  static async searchInMetadata(
    metadata: Map<string, string> | HashMap,
    searchString: ?string,
    assetIdFilterList: ?Array<AssetIdJson>,
    options = false
  ): Promise<FilesResponseData> {
    debug(
      '[searchInMetadata(metadata: %o, searchString: %s, assetIdFilterList: %o)]',
      metadata,
      searchString,
      assetIdFilterList
    );
    //Returns a new Iterator object that contains an array of [key, value] for each element in the Map object in insertion order.
    // metadata.clear();
    // metadata.set("IPTC_AI Object Name", "one");
    // metadata.set("IPTC_AI Object", "object")
    let searchMessage = new SearchMessage();
    const properties: Array<string> = [];
    var values: Array<string> = [];
    var logicalRelationShip: Array<string> = [];
    const valueMatchEnums: Array<string> = [];
    if (metadata.toArray) {
      //$FlowFixMe
      metadata.toArray().forEach((entry) => {
        const { key, value } = entry;
        let propertyToValue = SearchUtil.getValueAndLogicalRelation(value, key);
        properties.concat(propertyToValue.keys);
        values.concat(propertyToValue.property);
        valueMatchEnums.concat(propertyToValue.valueMatchEnums);
        logicalRelationShip.concat(propertyToValue.logical);
        logicalRelationShip.push('AND');
      });
    } else {
      metadata.forEach(function (value: string, key: string, map: Map<string, string>) {
        let propertyToValue = SearchUtil.getValueAndLogicalRelation(value, key);
        properties.concat(propertyToValue.keys);
        values.concat(propertyToValue.property);
        valueMatchEnums.concat(propertyToValue.valueMatchEnums);
        logicalRelationShip.concat(propertyToValue.logical);
        if (properties.length > 1) {
          logicalRelationShip.push('AND');
        }
      });
    }
    const info: CurrentContextInfo = _.cloneDeep(Store.get(CONTEXT_INFO));
    searchMessage.setAssetIdFilterList(assetIdFilterList);
    searchMessage.setProperties(properties);
    searchMessage.setValues(values);
    searchMessage.setMetaPropertiesRelationship(logicalRelationShip);
    searchMessage.setValueMatchEnums(valueMatchEnums);
    searchMessage = SearchUtil.setCommonParameterOfSearchMessage(searchMessage);
    if (searchString) {
      searchMessage.setFileName(searchString);
      const searchType: SearchType = 'CONTAINS';
      searchMessage.setFileNameMatchEnum(searchType);
    }
    if (options) {
      searchMessage.setResetFilters(options.isReset);
      searchMessage.setCurrentContextInfo(options.info);
      if (options.resetAllExceptFilters && !options.isReset) {
        searchMessage.setResetAllExceptFilters(options.resetAllExceptFilters);
      }
    } else {
      const categoryList = Store.get(CATEGORY_LIST);
      const hasFilters = (categoryList || []).filter((category) => category.isHasAnySelectedItem()).length > 0;
      searchMessage.setResetAll(!hasFilters);
      searchMessage.setCurrentContextInfo(info);
      searchMessage.setResetAllExceptFilters(true);
      searchMessage.setDirtyArg(SearchParamUtil.TEXT);
    }
    const searchQuery = new SearchQuery();
    searchQuery.message = searchMessage;
    //AI_TYPE
    const res: FilesResponseData = await searchQuery.run(true);
    //MetadataUtil.addAssetIdInMetadataMapOfAsset(res.getResultFiles());
    return res;
  }

  static extractSystemMetadataFilters(searchMessage: SearchMessage): Array<SystemMetadataFilter> {
    const metadataFilters: Array<SystemMetadataFilter> = [];
    if (searchMessage) {
      if (searchMessage.getAuthor() !== null) {
        metadataFilters.push({
          key: 'SYST_Author',
          value: searchMessage.getAuthor(),
          vme: searchMessage.getAuthorMatcher()
        });
      }
      if (searchMessage.getTypeFilters() !== null) {
        searchMessage.getTypeFilters().forEach((typeFilter) => {
          metadataFilters.push({
            key: 'SYST_File Type Filter',
            value: typeFilter,
            vme: 'EXACT'
          });
        });
      }
      if (searchMessage.getLog() !== null) {
        metadataFilters.push({
          key: 'SYST_LogMsg',
          value: searchMessage.getLog(),
          vme: searchMessage.getLogMatcher()
        });
      }
      if (searchMessage.getBeginDate() !== null || searchMessage.getLastDate() !== null) {
        metadataFilters.push({
          key: 'SYST_Date',
          value: (searchMessage.getBeginDate() !== null ? searchMessage.getBeginDate() : '')
            + '-' + (searchMessage.getLastDate() !== null ? searchMessage.getLastDate() : ''),
          vme: 'IN_RANGE'
        });
      }
      if (searchMessage.getPathActionFilters() !== null) {
        const filters: Array = searchMessage.getPathActionFilters();
        const notOps: Array = searchMessage.getNotPathActionList();
        for (var i: number = 0; i < filters.length; i++) {
          var filter: string = filters[i];
          var notOp: boolean = notOps[i];
          metadataFilters.push({
            key: 'SYST_Path Action',
            value: filter,
            vme: (notOp ? 'NOT_CONTAINS' : 'EXACT')
          });
        };
      }
      if (searchMessage.getLinkageRoleFilters() !== null) {
        const filters: Array = searchMessage.getLinkageRoleFilters();
        const notOps: Array = searchMessage.getNotLinkageRoleList();
        for (var i: number = 0; i < filters.length; i++) {
          var filter: string = filters[i];
          var notOp: boolean = notOps[i];
          metadataFilters.push({
            key: 'SYST_Linkage Role',
            value: filter,
            vme: (notOp ? 'NOT_CONTAINS' : 'EXACT')
          });
        };
      }
      if (searchMessage.getFileName() !== null) {
        metadataFilters.push({
          key: 'SYST_File Name',
          value: searchMessage.getFileName(),
          vme: searchMessage.getFileNameMatchEnum()
        });
      }
    }
    return metadataFilters;
  }

  static async fetchAssetsByParentFuid(parentFuid: number) {
    const query = new SearchQuery();
    const msg = new SearchMessage();
    // TODO: what to put in msg?
    query.message = msg;
    const res: FilesResponseData = await query.run();
    return res.getResultFiles();
  }

  static async runNextPageQuery(filterText = undefined): Promise<FilesResponseData> {
    console.log('filter text ' + filterText);
    try {
      const query = new LoadNextSearchPageQuery();
      query.message = new LoadNextSearchPageMsg();
      if (filterText) {
        query.message.setSearchInsideText(filterText);
      }
      const res: FilesResponseData = await query.run();
      //MetadataUtil.addAssetIdInMetadataMapOfAsset(res.getResultFiles());
      return res;
    } catch (err) {
      debug('[runNextPageQuery()] error: ', err);
      throw err;
    }
  }

  static getFuidKey(key: string, value: string): number {
    let fuid: number = 0;
    if ((fuid = _.toInteger(value)) > 0) {
      const input = key.toLowerCase().trim();

      if (input === 'fuid' || input === 'asset id' || input === 'asset' || input === 'id') {
        return fuid;
      }
    }
    return fuid;
  }

  static addAssetIdFilterToSearchMessage(message: SearchMessage, fuid: number): void {
    let assetIdFilterList: Array<AssetIdJson> = message.getAssetIdFilterList();
    if (!assetIdFilterList) {
      assetIdFilterList = [];
      message.setAssetIdFilterList(assetIdFilterList);
    }
    const assetIdJson: AssetIdJson = new AssetIdJson();
    assetIdJson.setMaxFuid(fuid).setMinFuid(fuid);
    assetIdFilterList.push(assetIdJson);
  }

  static createAssetIdJson(fuid: number): AssetIdJson {
    const assetIdJson: AssetIdJson = new AssetIdJson();
    assetIdJson.setMaxFuid(fuid).setMinFuid(fuid);
    return assetIdJson;
  }

  static escapeRegExp(str: string): string {
    return str.replace(/[{}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  //get Url parms
  static getSearchQueryParams(): Object {
    const searchedData = Storage.get('ADV_');
    debug('[getSearchQueryParams()]: ', searchedData);
    return JSON.parse(searchedData);
  }

  //Get Value of field from Query Param
  static findFieldInQueryParams(key: string): Object {
    const data = SearchUtil.getSearchQueryParams();
    let object = [];
    if (!_.isEmpty(data)) {
      object = _.get(data, key);
    }
    debug('[findFieldInQueryParams()]: ', object);
    if (object != undefined) {
      return SearchUtil.getFilterParams(object);
    }
    return null;
  }

  static getFilterParams(fieldParam: Array): Object {
    let field = fieldParam;
    let filterField = { propValue: null, entries: [] };
    if (!_.isEmpty(field)) {
      filterField.propValue = field[0];
      field.splice(0, 1);
      if (!_.isEmpty(field)) {
        filterField.entries = SearchUtil.createEntryObject(field);
      }
    }
    debug('[getFilterParams()]: ', filterField);
    return filterField;
  }

  static createEntryObject(entries: Array): Array {
    let i = 0,
      arr = [];
    while (i < entries.length) {
      arr.push({ id: Date.now() + i, type: entries[i], value: entries[i + 1] });
      i = i + 2;
    }
    debug('[createEntryObject()]: ', arr);
    return arr;
  }

  static getSearchFacts(filterName: string) {
    const query = new ApplyFilterQuery();
    const msg = new ApplyFilterMsg();
    msg.setFilterName(filterName);
    query.message = msg;
    query.run().then(
      (resp) => {
        console.log(resp);
        // window.gs.searchhasDirtyFilters = resp.getFilesResponseData().isHasDirtyFilters();
        // const searchString = resp.getSearchString();
        // this.onSearchQueryResponse(resp.getFilesResponseData(), searchString);
      },
      (error) => {
        console.log(error);
        //  this.onErrorInQuery(error);
      }
    );
  }

  static issueFacetQuery = async (useCurrentFuidSet: boolean = true) => {
    try {
      const query = new GetFacetsQuery();
      const msg: GetFacetsMsg = new GetFacetsMsg();
      msg.setUseCurrentFuidSet(useCurrentFuidSet);
      query.message = msg;
      debug('[issueFacetQuery()] running query: ', query);
      const res: GetFacetsRes = await query.run();
      debug('[issueFacetQuery()] response: ', res);
      const categoryList = res.getCategoryList();
      return categoryList;
      //Store.put(CATEGORY_LIST, categoryList);
    } catch (err) {
      debug('[issueFacetQuery()] error: ', err);
    }
  };

  static getFilterResult = async (
    categoryId: string,
    selected: boolean,
    facetedItemInfo: FacetedItemInfo,
    parentNode: ?FacetedItemInfo
  ) => {
    try {
      const res: FilesStatData = await runCategoryChangeQuery(categoryId, selected, facetedItemInfo, parentNode);
      debug('[getFilterResult()] res: ', res);
      console.log(categoryId, selected, facetedItemInfo, parentNode);
      Store.put(ADV_SRCH_ASSETS, res.getResultFiles());
      //Store.put(ADV_SRCH_COLLECTIONS, res.getMatchedCollection());
      //this.setState({ assets: res.getResultFiles(), totalCount: res.getTotalFiles() });
    } catch (err) {
      console.log(err);
      debug('[getFilterResult()] error: ', err);
      Store.put(ADV_SRCH_ASSETS, []);
      Store.put(ADV_SRCH_COLLECTIONS, []);
    }
  };

  static setSearched(key: string, searchString: string): void {
    Storage.setSessionStorage(key, searchString);
  }

  static getSearched = (key: string): string => {
    return Storage.getSessionStorage(key);
  };

  static removeItemfromStorage(key: string): void {
    Storage.removeSessionStorage(key);
  }

  static autoCompleteSearch = (metadataKeyName: string, value: string, callback: Function): void => {
    const query = new GetMetadataHelpQueryQuery();
    const msg = new GetMetadataHelpQueryMsg();
    msg.setMetadataProperty(metadataKeyName);
    msg.setPrefix(value);
    query.message = msg;
    debug('[issueQueryToGetAutoCompleteValues()] running query: ', query);
    query.run().then(
      (resp) => {
        debug('[issueQueryToGetAutoCompleteValues()] response: ', resp);
        if (resp.isSuccess()) {
          callback(resp.getEntries());
        } else {
          callback(null);
        }
      },
      (error) => {
        if (!error) error = 'An error occurred while reading autocomplete values for prop ' + metadataKeyName;
        debug('[issueQueryToGetAutoCompleteValues()] error: ', error);
        callback(null);
      }
    );
  };

  // get and set Advance Search data in localstorage.
  //static SearchDataMap: Array<any> = new Array();

  //static metadataSortSequance: Array<string> = new Array();

  static setMetadataSetting = function (valueToTop: string, groupCodes: Array<string>, opertion: string): void {
    let key: ?string = null;
    let value: ?string = null;
    if (opertion === HIDE) {
      /* const hideGroupCode: Array<string> = SearchUtil.getMetadataSetting(
        SaveSettings.ADVANCE_SEARCH_HIDE_METADATA_CODE
      );
      hideGroupCode.push(valueToTop);
      value = hideGroupCode.join(',');
      key = SaveSettings.ADVANCE_SEARCH_HIDE_METADATA_CODE; */
    }
    if (opertion === PIN_TO_TOP) {
      _.remove(groupCodes, (code) => {
        return code === valueToTop;
      });
      groupCodes.unshift(valueToTop);
      value = groupCodes.join(',');
      key = SaveSettings.ADVANCE_SEARCH_SORTED_METADATA_CODE;
    }

    if (key) {
      SaveSettings.save(key, value);
    }
  };

  /* static getMetadataSetting = function(operation: string): Array<string> {
    return SearchUtil.metadataSortSequance;
  }; */
}
